import React from 'react';
import classNames from 'classnames';

type TabButtonTvChannelProps = {
  title: string;
  selected: boolean;
  controls: string;
  onClick: () => void;
};

const TabButtonTvChannel = ({onClick, title, selected, controls}: TabButtonTvChannelProps) => (
  <button
    onClick={onClick}
    className={classNames('TabButtonTvChannel', {'TabButtonTvChannel--selected': selected})}
    role='tab'
    aria-selected={selected}
    aria-controls={`${controls}-tab`}>
    {title}
  </button>
);

export default TabButtonTvChannel;
